// PURPOSE: The "← Section" link at the top of record pages, which returns to where the person came from when that was Home.
// CONTRACT: Phin 2026-10-18: opening a record from Home and pressing back returns to Home, not the section list.
// DEPENDS: react-router location state set by HomeBoard.
// CEILING: Presentation only; falls back to the record's own section.
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export type CameFrom = { to: string; label: string };
export const FROM_HOME: CameFrom = { to: '/', label: 'Home' };

export function BackLink({ to, label }: CameFrom) {
 const from = (useLocation().state as { from?: CameFrom } | null)?.from;
 const target = from?.to?.startsWith('/') ? from : { to, label };
 return <Link className="back-link" to={target.to}><ArrowLeft size={15} />{target.label}</Link>;
}
